/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolForestIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-forest"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12.95 21.68L12.95 20.13L18.05 20.13L18.05 21.68Q18.05 22.23 17.66 22.61Q17.27 23 16.73 23L14.28 23Q13.72 23 13.34 22.61Q12.95 22.23 12.95 21.68ZM5.95 21.68L5.95 18.9L0.68 18.9Q-0.13 18.9 -0.49 18.2Q-0.85 17.5 -0.42 16.85L2.25 12.8L2.25 12.8Q1.6 12.8 1.3 12.22Q1 11.65 1.38 11.13L7.42 2.45Q7.63 2.17 7.91 2.04Q8.2 1.9 8.5 1.9Q8.8 1.9 9.09 2.04Q9.38 2.17 9.57 2.45L15.63 11.13Q16 11.65 15.7 12.22Q15.4 12.8 14.75 12.8L14.75 12.8L17.45 16.85Q17.9 17.5 17.52 18.2Q17.15 18.9 16.35 18.9L11.05 18.9L11.05 21.68Q11.05 22.23 10.66 22.61Q10.28 23 9.72 23L7.28 23Q6.72 23 6.34 22.61Q5.95 22.23 5.95 21.68ZM20.43 18.9L17.23 14.13L17.23 14.13Q17.9 14.13 18.2 13.53Q18.5 12.93 18.13 12.38L12.8 4.75L14.4 2.45Q14.6 2.17 14.9 2.02Q15.2 1.88 15.5 1.88Q15.8 1.88 16.09 2.02Q16.38 2.17 16.57 2.45L22.63 11.13Q23 11.65 22.7 12.22Q22.4 12.8 21.75 12.8L21.75 12.8L24.43 16.85Q24.85 17.5 24.49 18.2Q24.13 18.9 23.32 18.9Z" fill={color} />
    </svg>
  );
}
